import apiClient from '../index'

const normalizeDateValue = (value) => {
  if (!value) return null
  if (typeof value?.format === 'function') return value.format('YYYY-MM-DD')
  return value
}

const normalizeBatchPayload = (data = {}) => ({
  ...data,
  startDate: normalizeDateValue(data.startDate),
  endDate: normalizeDateValue(data.endDate),
})

export const createBatch = (data) => apiClient.post('/batch', normalizeBatchPayload(data))
export const getBatch = ({ skip, limit, title, trainerId, processId, startDate, endDate }) =>
  apiClient.get('/batch', {
    params: {
      skip,
      limit,
      title,
      trainerId,
      processId,
      startDate,
      endDate,
    },
  })
export const updateBatch = (id, data) =>
  apiClient.patch(`/batch/${id}`, normalizeBatchPayload(data))
export const getBatchById = (id) => apiClient.get(`/batch/${id}`)
